import React from "react"
import { Col, Container, Row } from "reactstrap"

const ListUser = () => {
  return (
    <div className="page-content">
      <Container fluid>
        <Row>
          <Col>
            <div className="border border-danger">ListUser</div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default ListUser
